/******************************************************************************
 *** SysOgnzMng ** 시스템 관리 > 본부 및 지부 관리 * 시스템관리자가 추가/수정/삭제
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Button from "@/js/common/ui/Button";
import Util from "@/js/common/Util";
import React from "react";
import SelectBox from "@/js/common/ui/input/SelectBox";
import Axios from "@/js/common/Axios";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "@/js/system/common/DialogTitleBar";
import SysOgnzSaveDialog from "./dialog/SysOgnzSaveDialog";
import { useRecoilValue } from "recoil";
import * as Atom from "@/js/common/Atom";

const SysOgnzMng = () => {
    const userInfo = useRecoilValue(Atom.userInfo);
    // 검색 조건
    const [upOgnzCd, setUpOgnzCd] = React.useState<string>(userInfo.upOgnzCd); // 본부 코드
    const [callTime, setCallTime] = React.useState<Date>(new Date());

    // 목록 데이터
    const [dataArr, setDataArr] = React.useState<any[]>([]);

    // 모달 상태
    const [modalOpen, setModalOpen] = React.useState<boolean>(false);
    const [ognzCd   , setOgnzCd] = React.useState<string>(""); // NEW: "", EDIT: ognzCd

    // 조회 (조회화면 방식 그대로)
    React.useEffect(() => {
        AppContext.showSpinner();

        Axios.dataAccess({
            url: "system/sys/ognz/select-ognz-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                upOgnzCd: upOgnzCd === "00" ? "" : upOgnzCd,
            },
            onSuccessFn: (res: any) => {
                setDataArr(res.result.list || []);
                AppContext.hideSpinner();
            },
        });
    }, [callTime, upOgnzCd]);

    // 삭제 (메인에서 처리하는 기능)
    const handleDelete = (row: any) => {
        if (Util.isEmpty(row.ognzCd)) return;

        AppContext.openAlert({
            title: "삭제",
            msg: `"${row.ognzNm}" 지부를 삭제하시겠습니까?`,
            icon: "warning",
            confirmText: "삭제",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url: "system/sys/ognz/delete-ognz.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        ognzCd: row.ognzCd,
                    },
                    onSuccessFn: () => {
                        AppContext.hideSpinner();
                        AppContext.openAlert({
                        title: "지부 삭제 완료",
                        msg: "지부 정보가 삭제되었습니다.",
                        icon: "success",
                        });
                        setCallTime(new Date());
                    },
                });
            },
        });
    };
    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            {/* 타이틀 */}
            <div className="mt5">
                <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">본부 및 지부 관리</span>
                <div className="bdt3 bdc007bff pb10"></div>
            </div>

            {/* 검색 영역 */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC gap14 jcSb">
                    <div className="dpFlx aiC gap14">
                        <div className="dpFlx aiC">
                            <span className="w40 fm-c fs15 fc333333 ls1 taL">본부</span>
                            <SelectBox value={upOgnzCd}
                                width={220} height={36}
                                fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                background="#fff" paddingRight={8}
                                codeArray={[{ code: "", name: "전체" }].concat(Util.getUpOrgCodeArray("01").filter(item => item.code !== "00"))}
                                placeholder="전체"
                                onChangeFunc={(data: string) => setUpOgnzCd(data)}
                            />
                        </div>

                        {/* 지부 수 표시 */}
                        <div className="ml20 flx1 bd1 bdcDDDDDD bdrd8 bgcFAFAFA p10 boxShadowSoft">
                            <div className="dpFlx aiC">
                                <div className="fm-c fs13 fc666666">총 지부 수</div>
                                <div className="fm-b fs20 fc007bff pl20">{dataArr.length}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 목록 타이틀 */}
            <div className="dpFlx aiC jcSb mb10 h44">
                <div className="fm-b fs16 fc007bff ls1 fw700">
                    <span>지부 목록</span>
                </div>
                {userInfo.systemAdmin === "Y" && (
                <Button buttonName="지부 추가"
                    width={110} height={40}
                    fontFamily="fm-b" fontSize={15} letterSpacing={-1}
                    variant="styCompleteBtn"
                    borderRadius={6} buttonClass="dpFlx aiC jcC"
                    onClickFunc={() => {
                        setOgnzCd(""); // NEW
                        setModalOpen(true);
                    }}
                />
                )}
            </div>

            {/* 테이블 */}
            <div className="w100p bsBdb bgcFDFCFC bdt1 bdcC5C5C5">
                <table className="w100p tlF tbl-collapse">
                    <colgroup>
                        <col style={{ width: "30%" }} />
                        <col style={{ width: "30%" }} />
                        <col style={{ width: "40%" }} />
                    </colgroup>
                    <thead>
                        <tr>
                            {["지방본부", "지부", "관리"].map((label) => (
                                <th key={label} className="p0 bd1 bdcEDEDED">
                                    <div className="h40 dpFlx aiC jcC pw12 bgcF1F8FF fm-Pretendard-Medium fs14 fw400 fc34495e ls1 wsNw ofH toE">
                                        {label}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {dataArr.length === 0 ? (
                            <tr>
                                <td colSpan={3} className="p0 bd1 bdcEDEDED">
                                    <div className="ph25 taC fc999999 fm-Pretendard-Regular fs13 ls075">조회된 데이터가 없습니다.</div>
                                </td>
                            </tr>
                        ) : (
                            dataArr.map((row: any, idx: number) => (
                                <tr key={`${row.ognzCd}_${idx}`} className="bgcF9F9F9-hover transitionBgc">
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC pw12 fm-Pretendard-Light fs15 fm-c fc666666 ls075 wsNw ofH toE">
                                        {row.upOgnzNm || ""}
                                        </div>
                                    </td>

                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC pw12 fm-Pretendard-Light fs15 fm-c fc666666 ls075 wsNw ofH toE">
                                        {row.ognzNm || ""}
                                        </div>
                                    </td>

                                {userInfo.systemAdmin === "Y" ? (
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC jcC gap10 pw12">
                                        <Button  buttonName="수정"
                                            width={70} height={28}
                                            fontFamily="fm-b" fontSize={13} letterSpacing={-1}
                                            variant="styTempBtn"
                                            borderRadius={4} buttonClass="dpFlx aiC jcC"
                                            onClickFunc={() => {
                                            setOgnzCd(row.ognzCd);
                                            setModalOpen(true);
                                            }}
                                        />
                                        <Button buttonName="삭제"
                                            width={70} height={28}
                                            fontFamily="fm-b" fontSize={13} letterSpacing={-1}
                                            variant="styDeleteBtn"
                                            borderRadius={4} buttonClass="dpFlx aiC jcC"
                                            onClickFunc={() => handleDelete(row)}
                                        />
                                        </div>
                                    </td>
                                )
                                :
                                    <td className="p0 bd1 bdcEDEDED">
                                        <div className="h35 dpFlx aiC jcC pw12 fm-c fs13 fc828282 ls075">
                                            지부 추가/수정/삭제는 본부 관리자에게 문의하세요.
                                        </div>
                                    </td>
                                }
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* 지부 등록/수정 모달 (너가 쓰는 방식 그대로) */}
            <Modal modalOpen={modalOpen} dim={true} visible={true} titleEl={<DialogTitleBar title={Util.isEmpty(ognzCd) ? "지부 등록" : "지부 수정"} />}
                onCloseFunc={() => {
                    setOgnzCd("");
                    setModalOpen(false);
                }}
            >
                <SysOgnzSaveDialog
                    ognzCd={ognzCd}
                    setModalOpen={setModalOpen}
                    setCallTime={setCallTime}
                    upOgnzCdDefault={upOgnzCd}
                />
            </Modal>
        </div>
    );
};

export default SysOgnzMng;
